// @ts-nocheck
import {
    chain,
    LoadProducts,
} from "@insite/client-framework/Store/Components/ProductCarousel/Handlers/LoadCarouselProducts";
import { addToChainBefore, createChainHandler } from "@toolkit/Modules/client-framework/HandlerCreator";

export const PopulateExpand = createChainHandler("PopulateExpand", chain, props => {
    if (props.getProductCollectionParameter) {
        props.getProductCollectionParameter.expand = [
            ...(props.getProductCollectionParameter.expand || []),
            "variantTraits",
        ];
    }
});

addToChainBefore(chain, LoadProducts, PopulateExpand);
